var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNextz(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.372925,
    y: 0.408203,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#97144D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3108 17.4385C13.0179 17.1456 13.0179 16.6708 13.3108 16.3779L16.5305 13.1582L6.34113 13.1582C5.92691 13.1582 5.59113 12.8224 5.59113 12.4082C5.59113 11.994 5.92691 11.6582 6.34113 11.6582L16.5305 11.6582L13.3108 8.43853C13.0179 8.14564 13.0179 7.67077 13.3108 7.37787C13.6037 7.08498 14.0786 7.08498 14.3715 7.37787L18.9832 11.9702C19.2761 12.2631 19.1643 12.6456 18.8715 12.9385L14.3715 17.4385C14.0786 17.7314 13.6037 17.7314 13.3108 17.4385Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextz);
export default __webpack_public_path__ + "static/media/nextz.4a3979b1b91a2b128793ad5666f786ea.svg";
export { ForwardRef as ReactComponent };